/** PC 底部导航中的支付接入模板，使用模块外层 template_id。 */
export const PAYMENT_TEMPLATE_ID = 3;

interface FooterPaymentModule {
  id?: number;
  template_id?: number;
  content?: unknown;
}

export interface FooterPaymentContent {
  key: string;
  title: string;
  images: string[];
}

/** 保留后台图片顺序；空配置不回退到前端固定支付品牌。 */
export function getFooterPaymentModules(
  navList: readonly FooterPaymentModule[],
  assetBaseUrl: string,
): FooterPaymentContent[] {
  return navList.flatMap((module, index) => {
    if (
      module.template_id !== PAYMENT_TEMPLATE_ID ||
      typeof module.content !== 'object' ||
      module.content === null ||
      !('images' in module.content) ||
      !Array.isArray(module.content.images)
    ) {
      return [];
    }

    const images = module.content.images.flatMap((src: unknown) => {
      if (typeof src !== 'string' || !src.trim()) return [];
      const path = src.trim();
      // 后台上传资源位于 S3 根目录，不能使用前端静态资源的 /zeelool-next 前缀。
      return [
        /^(https?:)?\/\//.test(path)
          ? path
          : `${assetBaseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`,
      ];
    });
    if (images.length === 0) return [];

    const title =
      'title' in module.content && typeof module.content.title === 'string'
        ? module.content.title.trim()
        : '';

    return [{ key: `${module.id ?? index}`, title, images }];
  });
}
